import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 1400px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - 125px);
  padding: 20px;
  margin: auto;
  margin-top: 75px;
  overflow-y: auto;

  //Chat remova o scrollBar
  &::-webkit-scrollbar {
    display: none;
  }
`;
